var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kaxayowwoa",
    d: "M0.187 0.702L19.734 0.702 19.734 19 0.187 19z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M25 14.923V4.81c0-1.039-.875-1.914-1.913-1.914H4.1c-1.039 0-2.078.93-2.46 1.914L0 8.91v7.107h1.531c.273-1.64 1.694-2.844 3.388-2.844 1.695 0 3.116 1.204 3.389 2.844h7.304c.273-1.64 1.695-2.844 3.39-2.844 1.694 0 3.115 1.204 3.389 2.844L25 14.923zM7.652 8.91H1.203l1.476-3.664c.164-.547.82-1.258 1.421-1.258h3.552V8.91zm8.616-.957c0 .421-.341.763-.762.763h-1.209l.001 1.208c0 .422-.341.763-.762.763-.421.001-.763-.34-.763-.762l-.001-1.208h-1.208c-.421 0-.762-.34-.762-.763 0-.42.341-.762.762-.762h1.208V5.982c-.001-.42.341-.763.762-.763s.763.341.763.762v1.21h1.208c.421-.002.763.34.763.761z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(2 .298)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xfkcrwympb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kaxayowwoa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M5.652 16.266C5.652 17.798 4.45 19 2.92 19 1.39 19 .187 17.798.187 16.266c0-1.53 1.202-2.733 2.732-2.733 1.531 0 2.733 1.202 2.733 2.733zM4.286 2.342c0-.93.383-1.64 1.312-1.64.93 0 1.312.71 1.312 1.64H4.286zm15.448 13.924c0 1.532-1.202 2.734-2.732 2.734-1.53 0-2.734-1.202-2.734-2.734 0-1.53 1.203-2.733 2.734-2.733 1.53 0 2.732 1.202 2.732 2.733z",
    mask: "url(#xfkcrwympb)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.99aee5b361974d8e0dd8cc11fb63066b.svg";
export { ForwardRef as ReactComponent };